<template>
    <alert-modal
        :title="titleCopy"
        :superTitle="$t('SWITCH_POP_SUPER')"
        @close="close"
        @confirm="confirm"
    >
        <div class="cz2__modal-popup__copy">
            {{ bodyCopy }}
        </div>

        <div
            aria-hidden="true"
            class="cz2__switch-pop-wrapper"
        >
            <div
                :style="{ backgroundImage: `url(${pop1PreviewImage})` }"
                class="cz2__switch-pop-snapshot"
            />

            <img
                v-if="isMariners"
                src="../assets/images/branded/seattle-storm/ss-switch-arrow.svg"
                alt=""
                width="68"
                height="49"
                :class="{ flip: !isFirstPop }"
                class="cz2__switch-pop-arrow"
            >

            <img
                v-else
                src="../assets/icons/switch-arrow.svg"
                alt=""
                width="68"
                height="49"
                :class="{ flip: !isFirstPop }"
                class="cz2__switch-pop-arrow"
            >

            <div
                :style="{ backgroundImage: `url(${pop2PreviewImage})` }"
                class="cz2__switch-pop-snapshot"
            />
        </div>

        <div class="cz2__ai-modal__buttons">
            <template v-if="canDoAiSelfie">
                <selfie-button :from-switch-modal="true" />

                <btn
                    black
                    @click="openAiModal"
                >
                    {{ $t('AI_UPLOAD') }}
                </btn>

                <btn
                    gray
                    @click="confirm"
                >
                    {{ $t('AI_BUILD') }}
                </btn>
            </template>

            <template v-if="!canDoAiSelfie">
                <btn
                    gray
                    @click="confirm"
                >
                    {{ $t('ACTION_CONTINUE') }}
                </btn>
            </template>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    #cz2.cz2 {
        .cz2__modal-popup__header {
            text-transform: none;
        }

        .cz2__switch-pop-wrapper {
            display: flex;
            justify-content: center;
            gap: 16px;
        }

        .cz2__switch-pop-snapshot {
            margin-bottom: 16px;

            flex: 1 1 auto;
            aspect-ratio: 675 / 900;

            background-size: contain;
            background-repeat: no-repeat;
        }

        .cz2__switch-pop-arrow {
            align-self: center;

            &.flip {
                transform: scaleX(-1);
            }
        }

        .cz2__ai-modal__buttons {
            overflow: hidden;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 4px;

            .cz2__btn {
                height: 40px;

                &:hover {
                    font-size: 18px;
                }
            }
        }
    }
</style>

<script>
    import popPlaceholder from '../assets/images/pop-placeholder.png';

    import AlertModal from './ui/AlertModal.vue';
    import SelfieButton from './ai/SelfieButton.vue';
    import Btn from './ui/Btn.vue';

    export default {
        components: {
            AlertModal,
            SelfieButton,
            Btn,
        },

        computed: {
            controller1() {
                return this.$store.getters.popControllers[0];
            },

            controller2() {
                return this.$store.getters.popControllers[1];
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.controller1;
            },

            pop1PreviewImage() {
                return this.$store.state.customizer.popPreviewImageByController[this.controller1.id] ?? popPlaceholder;
            },

            pop2PreviewImage() {
                return this.$store.state.customizer.popPreviewImageByController[this.controller2.id] ?? popPlaceholder;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            titleCopy() {
                return this.isKiosk ? this.titleCopyKiosk : this.titleCopyWeb;
            },

            titleCopyWeb() {
                return this.isFirstPop ? this.$t('SWITCH_POP_TITLE') : this.$t('SWITCH_POP_TITLE_2');
            },

            titleCopyKiosk() {
                return this.isFirstPop ? this.$t('SWITCH_POP_TITLE_KIOSK') : this.$t('SWITCH_POP_TITLE_2_KIOSK');
            },

            bodyCopy() {
                return this.isKiosk ? this.bodyCopyKiosk : this.bodyCopyWeb;
            },

            bodyCopyWeb() {
                return this.isFirstPop ? this.$t('SWITCH_POP_BODY') : this.$t('SWITCH_POP_BODY_2');
            },

            bodyCopyKiosk() {
                return this.isFirstPop ? this.$t('SWITCH_POP_BODY_KIOSK') : this.$t('SWITCH_POP_BODY_2_KIOSK');
            },

            isMariners() {
                return this.$store.state.isMariners;
            },

            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            canDoAiSelfie() {
                if (this.globalSettings['fun-ai-selfie'] === 'true') {
                    return true;
                }

                return false;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showSwitchPopModal', false);
            },

            confirm() {
                const current = this.$store.state.customizer.viewController;
                const notCurrent = this.$store.getters.popControllers.find((x) => x !== current);
                const startGroup = notCurrent.blueprint.groups.find((g) => g.custom && g.custom['fun-start-group'] === 'true');
                const nameGroup = notCurrent.blueprint.groups.find((g) => g.code === 'Name');
                const targetGroup = this.isFirstPop ? startGroup : nameGroup;

                this.$store.dispatch('selectPop', notCurrent);
                this.$store.dispatch('showGroup', targetGroup);

                // Restore default/out of box view when switching to pop 2.
                this.$store.dispatch('setSelectedToggleView', 'Main');
                this.$store.dispatch('setPreferredView', null);

                this.close();
            },

            openAiModal() {
                this.confirm();
                this.$store.dispatch('showAiModal', true);
                this.$store.dispatch('setLaunchedFromSwitchModal', true);
            },
        },
    };
</script>
